import { createSlice } from "@reduxjs/toolkit";

export type User = {
  id: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  verified: boolean;
  profilePicture: string | undefined;
};

export const initialState: { value: User | null } = { value: null };

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { setUser } = userSlice.actions;

export default userSlice.reducer;
